<div class="flex flex-col items-center w-10">
	<svg
		[class.p-stroke-component-background]="!isStarted"
		[class.p-stroke-primary]="isStarted"
		fill="none"
		height="14"
		viewBox="0 0 14 14"
		width="14"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="7" cy="7" r="5" stroke-width="4"></circle>
	</svg>
	<svg
		[class.p-stroke-component-background]="!isStarted"
		[class.p-stroke-primary]="isStarted"
		fill="none"
		height="32"
		viewBox="0 4 4 32"
		width="4"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.72656 38.2958L1.72656 2.29581"
			stroke-linecap="round"
			stroke-width="2"
		></path>
	</svg>
</div>
<span class="leading-none uppercase font-semibold text-xs">
	{{ (section.localization$ | async)?.name }}
</span>
